module.exports = __webpack_public_path__ + "img/aomen3.e57d2c6d.jpg";